export const FETCH_BUNDLE_BASKET_OFFERS_PENDING = 'FETCH_BUNDLE_BASKET_OFFERS_PENDING';
export const FETCH_BUNDLE_BASKET_OFFERS_REJECTED = 'FETCH_BUNDLE_BASKET_OFFERS_REJECTED';
export const FETCH_BUNDLE_BASKET_OFFERS_FULFILLED = 'FETCH_BUNDLE_BASKET_OFFERS_FULFILLED';
export const CLEAR_BUNDLE_BASKET_OFFER = 'CLEAR_BUNDLE_BASKET_OFFER';



// WEBPACK FOOTER //
// ./src/constants/bundleBasketOffers.js